// extracted by mini-css-extract-plugin
export var fadeInOut = "_x-3";
export var icon = "_x-4";
export var savedIndicator = "_x-2";
export var savingIndicator = "_x-0";
export var spin = "_x-1";